// Web Audio API synth chimes — no external assets needed.
let ctx = null;
let muted = false;
try {
  muted = localStorage.getItem("sl_muted") === "1";
} catch {
  // ignore
}
export const setMuted = (v) => {
  muted = v;
  try {
    localStorage.setItem("sl_muted", v ? "1" : "0");
  } catch {
    // ignore
  }
};
export const isMuted = () => muted;
const getCtx = () => {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const tone = (freq, dur, type = "sine", gain = 0.18, delay = 0) => {
  if (muted) return;
  const ac = getCtx();
  if (!ac) return;
  const t0 = ac.currentTime + delay;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  g.gain.setValueAtTime(0, t0);
  g.gain.linearRampToValueAtTime(gain, t0 + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g).connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.05);
};

const sweep = (f1, f2, dur, type = "sawtooth", gain = 0.12, delay = 0) => {
  if (muted) return;
  const ac = getCtx();
  if (!ac) return;
  const t0 = ac.currentTime + delay;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(f1, t0);
  osc.frequency.exponentialRampToValueAtTime(f2, t0 + dur);
  g.gain.setValueAtTime(0, t0);
  g.gain.linearRampToValueAtTime(gain, t0 + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g).connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.05);
};

export const sfx = {
  questComplete: () => {
    tone(880, 0.12, "triangle", 0.16);
    tone(1320, 0.16, "triangle", 0.14, 0.07);
  },
  questUncheck: () => {
    tone(440, 0.08, "square", 0.08);
  },
  click: () => {
    tone(660, 0.05, "square", 0.08);
  },
  completeDay: () => {
    tone(523.25, 0.12, "triangle", 0.18);
    tone(659.25, 0.12, "triangle", 0.16, 0.09);
    tone(783.99, 0.18, "triangle", 0.16, 0.18);
    tone(1046.5, 0.25, "sine", 0.18, 0.3);
  },
  levelUp: () => {
    sweep(220, 1200, 0.6, "sawtooth", 0.1);
    tone(523.25, 0.14, "triangle", 0.16, 0.25);
    tone(659.25, 0.14, "triangle", 0.16, 0.38);
    tone(783.99, 0.14, "triangle", 0.16, 0.51);
    tone(1046.5, 0.5, "sine", 0.2, 0.64);
    tone(1567.98, 0.4, "sine", 0.14, 0.7);
  },
  rankUp: () => {
    sweep(110, 880, 0.9, "sawtooth", 0.12);
    tone(392, 0.2, "triangle", 0.18, 0.4);
    tone(523.25, 0.2, "triangle", 0.18, 0.55);
    tone(659.25, 0.2, "triangle", 0.18, 0.7);
    tone(880, 0.6, "sine", 0.2, 0.85);
    tone(1318.5, 0.7, "sine", 0.16, 0.95);
  },
  warn: () => {
    tone(220, 0.18, "square", 0.12);
    tone(165, 0.22, "square", 0.12, 0.1);
  },
};

export const primeAudio = () => {
  getCtx();
};
